import { useCreateAppTrackingMutation } from '@app/services';
import { useAppSelector } from '@common';
import { selectAuthUser } from '@pages/Authentication/store';
import { useEffect } from 'react';

export function useAppTracking() {
    const [createAppTracking] = useCreateAppTrackingMutation();
    const user = useAppSelector(selectAuthUser);

    useEffect(() => {
        function sendLog(event: any) {
            const data: Dictionary = event.detail;
            data.userId = user?.id ?? localStorage.getItem('tempUserId');

            window.navigator.sendBeacon('/api/app-tracking', JSON.stringify(data));
        }

        document.addEventListener('App-Tracking', sendLog);

        return () => document.removeEventListener('App-Tracking', sendLog);
    }, [createAppTracking, user?.id]);
}
